import React from "react";
import { Box } from "@mui/material";
import takeWhile from "lodash/takeWhile";

import { MIN_WIDTH } from "./TableHeader/index";
import { MIN_CELL_WIDTH } from "./utils";

const styles = {
  cell: {
    p: 0,
    textAlign: "left",
    display: "flex",
    borderBottom: 1,
    borderColor: "grey.300",
  },
  frozenCell: {
    position: "sticky",
    zIndex: 2,
    backgroundColor: "inherit",
  },
  cellWrap: {
    position: "relative",
    height: "100%",
    width: "100%",
  },
  cellContent: {
    px: 2,
    py: 1,
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: "100%",
    width: "100%",
  },
  frozenShadow: {
    boxShadow: "2px 0 2px 0 rgba(0, 0, 0, 0.1)",
  },
};

const TableCell = ({
  fields,
  field,
  className,
  style,
  children,
  innerRef,
  nestedElement,
  contentProps,
  ...props
}) => {
  const showField = field.visible && !field.inactive;

  if (!showField) return <div style={{ display: "none" }} {...props} ref={innerRef}></div>;

  const visibleFields = fields.filter(fieldItem => fieldItem.visible && !fieldItem.inactive);

  const previousFields = takeWhile(visibleFields, h => h.id !== field.id);

  const previousFieldsAreFrozen = previousFields.every(item => item.isFrozen);

  const isFrozen = field.isFrozen && previousFieldsAreFrozen;
  const previousFieldsWidth = previousFields.reduce(
    (sum, prevField) => sum + Math.max(MIN_CELL_WIDTH, prevField.width || MIN_WIDTH),
    0
  );

  const { sx: contentSx, ...otherContentProps } = contentProps || {};

  return (
    <Box
      sx={{
        ...styles.cell,
        ...(isFrozen && styles.frozenCell),
      }}
      style={{
        left: previousFieldsWidth,
        width: Math.max(MIN_CELL_WIDTH, field.width || MIN_WIDTH),
        minWidth: Math.max(MIN_CELL_WIDTH, field.width || MIN_WIDTH),
        ...style,
      }}
      {...props}
      ref={innerRef}
    >
      <Box sx={styles.cellWrap}>
        <Box
          className={className}
          sx={{
            ...styles.cellContent,
            ...(isFrozen && styles.frozenShadow),
            ...contentSx,
          }}
          {...otherContentProps}
        >
          {children}
        </Box>

        {nestedElement}
      </Box>
    </Box>
  );
};

export default TableCell;
